var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle16X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 10.6667V8.00004M8.49992 5.33337H8.50659M15.1666 8.00004C15.1666 11.6819 12.1818 14.6667 8.49992 14.6667C4.81802 14.6667 1.83325 11.6819 1.83325 8.00004C1.83325 4.31814 4.81802 1.33337 8.49992 1.33337C12.1818 1.33337 15.1666 4.31814 15.1666 8.00004Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle16X16);
export default __webpack_public_path__ + "static/media/info-circle16x16.2db812778f07ebcf76efc21ff94d88bf.svg";
export { ForwardRef as ReactComponent };